import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"

export const PAY_TYPES = gql`
  query OffboardingPayTypes($globalPayroll: Boolean!) {
    offboardingPayTypes(globalPayroll: $globalPayroll) {
      id
      name
      percentageValue
      absoluteValue
    }
  }
`

export const useOffboardingPayTypes = (globalPayroll: boolean) =>
  useQuery(PAY_TYPES, {
    variables: { globalPayroll: globalPayroll },
  })
